import { render } from "./TamperingList.vue?vue&type=template&id=52a7b39a&scoped=true"
import script from "./TamperingList.vue?vue&type=script&lang=js"
export * from "./TamperingList.vue?vue&type=script&lang=js"

import "./TamperingList.vue?vue&type=style&index=0&id=52a7b39a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a7b39a"]])

export default __exports__